import { Image } from "@mantine/core";
import { Link } from "react-router-dom";

import logo from "../assets/logo-02-cropped.svg";
import LogoIcon from "./LogoIcon";

function Logo({ collapsed, color, ...props }) {
  return (
    <Link to="/app">
      {collapsed ? (
        <LogoIcon
          color={color}
          width={40}
          height={40}
          style={{ objectFit: "contain" }}
          {...props}
        />
      ) : (
        <Image
          src={logo}
          alt="Logo"
          style={{ objectFit: "contain" }}
          {...props}
        />
      )}
    </Link>
  );
}

export default Logo;
